module.exports = { "default": require("core-js/library/fn/set"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/set.js
 ** module id = 374
 ** module chunks = 0
 **/